import {Node} from 'slate';

export const validateNode = (node: any): Node => {
  if (!node || typeof node !== 'object') return {text: ''} as any;
  if (typeof node.text === 'string') return node;
  // It's an element, enforce children

  return {
    ...node,
    children:
      Array.isArray(node.children) && node.children.length > 0
        ? node.children.map(validateNode)
        : [{text: ''}]
  };
};
